import { useCallback } from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { useDispatch } from 'react-redux'
import { openModal } from '@store/modalsSlise'
import TYPES from '@modals/TYPES'
import s from './TiptapImage.module.css'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'

const TiptapImage = ({ node, editor, getPos }) => {
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(openModal({
      type: TYPES.TIPTAP_RESIZE_IMAGE, 
      data: { getPos, editor, node }
    }))
  }, [getPos, editor, node])

  return (
    <NodeViewWrapper className={s.resizableImageContainer}>
      <TooltipWrapper placement='right' title='Кликните по изображению, что изменить размер'>
        <img
          src={node.attrs.src}
          alt={node.attrs.alt}
          title={node.attrs.title}
          style={{
            width: node.attrs.width,
            maxWidth: '100%',
          }}
          className={s.resizableImage}
          onClick={handleClick}
        />
      </TooltipWrapper>
    </NodeViewWrapper>
  )
}

export default TiptapImage